










































import { defineComponent } from '@vue/composition-api';

import { useCreateProjectModal } from '@/modules/teamplan/organisms/Projects/CreateProjectModal';

import ModelModal from '@/components/molecules/ModelModal.vue';
import HeadingCenter from '@/components/molecules/HeadingCenter.vue';
import AtomLabel from '@/components/atoms/AtomLabel.vue';
import AtomButton from '@/components/atoms/AtomButton.vue';

export default defineComponent({
  name: 'CreateProjectModal',
  components: {
    ModelModal,
    HeadingCenter,
    AtomLabel,
    AtomButton,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    teamId: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    return useCreateProjectModal(props, emit);
  },
});
